import { handleApiCall } from "./Interactor";
import { format } from "date-fns";

export const getServiceDetails = (serviceId, onSuccessView, onFailedView) => {
  // https://staging.walletkuportal.com:1998/api/v3/services/75?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  handleApiCall(
    "GET",
    process.env.REACT_APP_GET_SERVICE_DETAILS + serviceId + "?authToken=" + authToken, {},
    (responseJSON) => {
      //dispatch response json to redux
    },
    onSuccessView,
    onFailedView
  )

}

export const getServiceSchedule = (serviceId, packageId, date, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/services/show_available_times?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  var params = {
    service_id: serviceId, 
    service_package_id: packageId, 
    date_available: date
  }
  handleApiCall(
    "POST",
    process.env.REACT_APP_GET_SERVICE_SCHEDULE + "?authToken=" + authToken, 
    params,
    (responseJSON) => {
      //dispatch response json to redux

    },
    onSuccessView,
    onFailedView
  )

}

export const getServiceMonthlySchedule = (serviceId, packageId, month, year, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/services/show_available_times_by_month_and_year?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  var params = {
    service_id: serviceId, 
    service_package_id: packageId, 
    month: month, 
    year: year
  }
  handleApiCall(
    "POST",
    process.env.REACT_APP_GET_SERVICE_MONTHLY_SCHEDULE + "?authToken=" + authToken, 
    params,
    (responseJSON) => {
      //dispatch response json to redux

    },
    onSuccessView,
    onFailedView
  )

}

export const getListService = (page, onSuccessView, onFailedView) => {
  // https://staging.walletkuportal.com:1998/api/v3/services/?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  handleApiCall(
    "GET",
    process.env.REACT_APP_GET_SERVICE_LIST + "?page=" + page + "&authToken=" + authToken, {},
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )

}

export const getListAddon = (onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/add_on_items?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  handleApiCall(
    "GET",
    process.env.REACT_APP_GET_ADDON_LIST + "?authToken=" + authToken, {},
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )
}

export const getListPaymentMethod = (total, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/faspay/channel?total_payment=10000&auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  handleApiCall(
    "GET",
    process.env.REACT_APP_GET_PAYMENT_METHOD_LIST + "?total_payment=" + total + "&authToken=" + authToken, {},
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )

}

export const checkoutBooking = (data, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/service_member_books
  var authToken = process.env.REACT_APP_AUTH_TOKEN;

  let addons = data.addons.map(addon => (
    {
      add_on_item_id: addon.id, 
      price: addon.price, 
      qty: addon.qty, 
      total: (addon.price * addon.qty)
    }
  ));

  let bookingTimes = data.schedules.time.map(time => (
    {
      service_id: data.venue.id, 
      service_date: format(data.schedules.date, 'yyyy-MM-dd'), 
      start_time: time.split(" - ")[0], 
      end_time: time.split(" - ")[1]
    }
  ));

  let subtotal = data.package.price * data.schedules.time.length;
  let totalAddon = 0;
  addons.forEach(addon => {
    totalAddon += addon.total;
  })
  let total = subtotal + totalAddon;

  let transactions = [];
  if (data.payment.isDP) {
    transactions.push(
      {
        community_id: 0, 
        payment_with: 'faspay', 
        pg_code: data.paymentMethod.pg_code, 
        pg_name: data.paymentMethod.pg_name, 
        package_unit: 'Sesi', 
        qty: data.schedules.time.length, 
        package_price: data.package.price, 
        total: subtotal, 
        admin_fee: data.paymentMethod.admin_fee, 
        is_dp: 1
      }
    );
    transactions.push(
      {
        community_id: 0, 
        payment_with: 'faspay', 
        pg_code: data.paymentMethod.pg_code, 
        pg_name: data.paymentMethod.pg_name, 
        package_unit: '', 
        qty: 0, 
        package_price: 0, 
        total: total - data.payment.DP, 
        admin_fee: data.paymentMethod.admin_fee, 
        is_dp: 0
      }
    );
  } else {
    transactions.push(
      {
        community_id: 0, 
        payment_with: 'faspay', 
        pg_code: data.paymentMethod.pg_code, 
        pg_name: data.paymentMethod.pg_name, 
        package_unit: 'Sesi', 
        qty: data.schedules.time.length, 
        package_price: data.package.price, 
        total: total, 
        admin_fee: data.paymentMethod.admin_fee, 
        is_dp: 0
      }
    );
  }

  let params = {
    service_member_book: {
      service_id: data.venue.id, 
      member_id: 0, 
      service_package_id: data.package.id, 
      service_date: format(data.schedules.date, 'yyyy-MM-dd'), 
      contact_name: data.contact.name, 
      contact_phone: data.contact.phone, 
      contact_email: data.contact.email, 
      total_payment: total, 
      total_dp: data.payment.DP,
      booking_times_attributes: bookingTimes, 
      add_on_item_service_member_books_attributes: addons, 
      transaction_services_attributes: transactions
    }
  }

  handleApiCall('POST', process.env.REACT_APP_CHECKOUT, 
    params, 
    (responseJSON) => {

    }, 
    onSuccessView, 
    onFailedView)
}

export const checkReview = (bookingID, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/service_ratings/check_review?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  var params = {
    order_id: bookingID
  }
  handleApiCall(
    "POST",
    process.env.REACT_APP_CHECK_REVIEW + "?authToken=" + authToken, 
    params, 
    (responseJSON) => {

    }, 
    onSuccessView, 
    onFailedView
  )
}

export const submitReview = (data, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/service_ratings?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  var params = {
    service_rating: {
      service_member_book_id: data.bookingID, 
      venue_condition: data.ratingLapang, 
      clean: data.ratingKebersihan, 
      facilities: data.ratingFasilitas, 
      security: data.ratingKeamanan, 
      transportation_access: 
      data.ratingAkses, 
      description: data.review, 
      hide_name: data.isAnonymous
    }
  }
  handleApiCall(
    "POST",
    process.env.REACT_APP_SUBMIT_REVIEW + "?authToken=" + authToken, 
    params, 
    (responseJSON) => {

    }, 
    onSuccessView, 
    onFailedView
  )
}

export const getListReviews = ({ venueId, page }, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/faspay/channel?total_payment=10000&auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  handleApiCall(
    "GET",
    process.env.REACT_APP_GET_REVIEW_LIST + "?service_id=" + venueId + "&page=" + page + "&authToken=" + authToken, {},
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )
}